module.exports = __webpack_public_path__ + "img/e683bc2.png";